import React from 'react'
import Header from './Header'
import Body from './Body'
import ReactToastify from '../../components/ReactToastify'

import 'react-toastify/dist/ReactToastify.css'

interface User {
    accessToken?: string
    firstName?: string
    picture?: string
}

interface LayoutProps {
    user: User
    errors: Error[]
    removeError: (error: Error) => void
}

const Layout = ({
    user,
    errors,
    removeError,
}: LayoutProps) => {
    const [ shouldLoadToastify, setShouldLoadToastify ] = React.useState(false)

    React.useEffect(() => {
        if (errors.length && !shouldLoadToastify) {
            setShouldLoadToastify(true)
        }
    }, [errors, shouldLoadToastify])

    return (
        <>
            <Header
                user={ user }
            />
            <Body
                renderToastContainer={() => (
                    shouldLoadToastify && <ReactToastify render={(Toastify: any) => <Toastify.ToastContainer />} />
                )}
            />
            { errors.map((error) => (
                <ReactToastify
                    key={ error.toString() }
                    render={(Toastify: any) => {
                        Toastify.toast.error(error.toString())
                        removeError(error)
                        return null
                    }}
                />
            ))}
        </>
    )
}

export default Layout
